/**
 * @fileoverview ESM mirror of ../buildConsoleWebUrl.js.
 *
 * See the CJS source for full documentation. Drift between the two is
 * caught by `tests/unit/buildConsoleWebUrl.test.js` (every case runs on
 * both halves) and `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/buildConsoleWebUrl
 */

import { PLATFORM_CONSOLE } from './registry.js';
import { composeConsoleOrigin, assertSafeRelativePath } from './tenantOrigin.js';

const CALLER = 'buildConsoleWebUrl';

function buildConsoleWebUrl(args) {
  if (!args || typeof args !== 'object') {
    throw new Error(`${CALLER}: arguments object is required`);
  }
  const { path, local } = args;
  if (typeof local !== 'boolean') {
    throw new Error(`${CALLER}: local is required (true on a localhost workstation)`);
  }
  assertSafeRelativePath(path, `${CALLER}: path`);
  return `${composeConsoleOrigin({ target: PLATFORM_CONSOLE, local })}${path}`;
}

export { buildConsoleWebUrl };
